export enum ETableAction {
  delete = 'delete',
  edit = 'edit',
  copy = 'copy',
  confirmEdit = 'confirmEdit',
  cancelEdit = 'cancelEdit',
  restore = 'restore',
}

export type TSortComparator<T> = (a: T, b: T, order: EColumnSort) => number

export interface HeadCell<T> {
  id: keyof T
  label: string
  colSpan?: number
  headerTooltip?: React.ReactNode
  isSortable?: boolean
  sortComparator?: TSortComparator<T>
}

export type TActionsHeadCell<T> = Omit<HeadCell<T>, 'id'> & {
  id: EActionsKey.actions
}

export type TSelectionHeadCell<T> = Omit<HeadCell<T>, 'id' | 'label'> & {
  id: ESelectionKey.selection
  label?: string
}

export type THeadCellWithActions<T> = Array<
  HeadCell<T> | TActionsHeadCell<T> | TSelectionHeadCell<T>
>

export enum EColumnSort {
  asc = 'asc',
  desc = 'desc',
}

export enum EActionsKey {
  actions = 'actions',
}

export enum ESelectionKey {
  selection = 'check',
}
